import React, { useState } from "react";
import { FiChevronDown, FiChevronRight, FiSettings } from "react-icons/fi";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import {
  createTemplate,
  resetJobOpportunityInfo,
  startNewPost,
  startWithTemplate,
} from "../../JobOpportunity/action";
import "./sidebar.css";
import useSessionStorage from "../../../hooks/useSessionStorage";
import { logOut } from "../../Login/action";
import { FiAlertTriangle } from "react-icons/fi";
import { mapURL } from "../../../helpers/domainURL";
import { getInstanceLogo } from "../../Instance/instance";

// eslint-disable-next-line import/no-anonymous-default-export
export default () => {
  const [subnav, setSubNav] = useState(true);
  const [userProfile, setUserProfile] = useState(true);
  const [candidateMenu, setCandidateMenu] = useState(true);
  const [employerDashboardMenu, setemployerDashboardMenu] = useState(true);
  const [multishiftsDashboardMenu, setMultishiftDashboardMenu] = useState(true);
  const [createjobopp, setCreateJobOpp] = useState(true);
  const [teams, setTeams] = useState(true);

  const [showSearch, setShowSearch] = useState(true);
  const showSubNav = () => setSubNav(!subnav);
  const showTeams = () => setTeams(!teams);
  const showUserProfile = () => setUserProfile(!userProfile);
  const storage = useSessionStorage();
  const login = storage.getItem("login");
  const shiftsAwaitingApprovalCount = useSelector((store) => store.notificationHeader.shiftsAwaitingApprovalCount);
  const shiftsAwaitingPaymentCount = useSelector((store) => store.notificationHeader.shiftsAwaitingPaymentCount);
  const shiftsAwaitingCorrectionCount = useSelector((store) => store.notificationHeader.shiftsAwaitingCorrectionCount);
  const uploadCount = useSelector((store) => store.notificationHeader.uploadCount);
  const notificationCount = useSelector((store) => store.notificationHeader.notificationCount);
  const incidentCount = useSelector((store) => store.notificationHeader.incidentCount);
  const inboxMailCount = useSelector((store) => store.notificationHeader.inboxMailCount);
  const smsCount = useSelector((store) => store.notificationHeader.smsCount);
  // const fiveStarDomain = ['emp5stardev.overturexl.com', 'qatestemployer5star.overturexl.com', '5staremployers.overturexl.com','5starstagingemployers.overturexl.com']
  // const isFiveStar = mapURL.fiveStarDomain.includes(window.location.hostname);
  // const lifeStyleDomain = ['dynamicemployers.overturexl.com']
  // const isLifeStyle = mapURL.lifeStyleDomain.includes(window.location.hostname);
  // const isNurseEtc = mapURL.nursesEtc.includes(window.location.hostname);
  const mainLogo = getInstanceLogo();
  const mainIcon = getInstanceLogo(true)
  const hoverToggle = () => {
    // if( document.body.classList.contains('sidenav-toggled')){
    //     document.body.classList.remove("sidenav-toggled")
    // }
    document.body.classList.add("sidenav-toggled-open");
  };
  const hoverUnToggle = () => {
    // if( document.body.classList.contains('sidenav-toggled-open')){
    //     document.body.classList.add("sidenav-toggled")
    // }
    document.body.classList.remove("sidenav-toggled-open");
  };
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const navigateToProfile = (event) => {
    event.preventDefault();
    navigate("/profile");
  };
  const Environment = process.env.NODE_ENV;
  function changeLocation(placeToGo) {
    if (window.location.pathname === placeToGo) {
      navigate(placeToGo, { replace: true });
      window.location.reload(false);
    } else {
      navigate(placeToGo);
    }
  }

  const logout = (event) => {
    event.preventDefault();
    storage.setItem("login", null);
    storage.setItem("userNotification", false);
    sessionStorage.clear();
    dispatch(logOut()).then(() => {
      navigate("/");
      window.location.reload();
    });
  };

  return (
    <>
      <div
        className="sticky sticky-margin"
        onMouseEnter={hoverToggle}
        onMouseLeave={hoverUnToggle}
      >
        <div className="app-sidebar__overlay" data-bs-toggle="sidebar"></div>
        <div className="app-sidebar ps scrollablenav"   >
          <div className="side-header">
            <a className="header-brand1" href="#">
              <img
                src="assets/images/brand/logo.png"
                className="header-brand-img desktop-logo"
                alt="logo"
              />
              <img
                src="assets/images/brand/logo-1.png"
                className="header-brand-img toggle-logo"
                alt="logo"
              />
              <img
                src={mainIcon ? mainIcon :
                    ((
                      login?.jobTypeFlags?.jobTypeList?.length
                        ? login?.jobTypeFlags?.jobTypeList[0]?.jobTypeId === 6
                        : login?.jobTypeFlags?.jobTypeId === 6 ||
                          login?.jobTypeFlags?.jobTypeList?.length
                          ? login?.jobTypeFlags?.jobTypeList[0]?.jobTypeId === 7
                          : login?.jobTypeFlags?.jobTypeId === 7
                    )
                      ? "assets/images/brand/ICON-DDS.png"
                      : "") ||
                    (login?.jobTypeFlags?.jobTypeId === 0 ||
                      login?.jobTypeFlags?.jobTypeId === 1 ||
                      login?.jobTypeFlags?.jobTypeId === 3 ||
                      login?.jobTypeFlags?.jobTypeId === 8 ||
                      login?.jobTypeFlags?.jobTypeId === 4 ||
                      login?.jobTypeFlags?.jobTypeId === 11
                      ? "assets/images/brand/ICON-XL.png"
                      : "") ||
                    (login?.jobTypeFlags?.jobTypeId === 2
                      ? "assets/images/brand/ICON-SEC.png"
                      : "") ||
                    (login?.jobTypeFlags?.jobTypeId === 5
                      ? "assets/images/brand/ICON-YUM.jpg"
                      : "") ||
                    "assets/images/brand/EMP-ICON.png"
                }
                className="header-brand-img light-logo"
                alt="logo"
              />
              <img
                // style={{ height: isFiveStar && "65px" }}
                src={mainLogo ? mainLogo :
                    ((
                      login?.jobTypeFlags?.jobTypeList?.length
                        ? login?.jobTypeFlags?.jobTypeList[0]?.jobTypeId === 6
                        : login?.jobTypeFlags?.jobTypeId === 6 ||
                          login?.jobTypeFlags?.jobTypeList?.length
                          ? login?.jobTypeFlags?.jobTypeList[0]?.jobTypeId === 7
                          : login?.jobTypeFlags?.jobTypeId === 7
                    )
                      ? "assets/images/brand/LOGO-DDS.png"
                      : "") ||
                    (login?.jobTypeFlags?.jobTypeId === 0 ||
                      login?.jobTypeFlags?.jobTypeId === 1 ||
                      login?.jobTypeFlags?.jobTypeId === 3 ||
                      login?.jobTypeFlags?.jobTypeId === 8 ||
                      login?.jobTypeFlags?.jobTypeId === 4 ||
                      login?.jobTypeFlags?.jobTypeId === 11
                      ? "assets/images/brand/LOGO-XL.png"
                      : "") ||
                    (login?.jobTypeFlags?.jobTypeId === 2
                      ? "assets/images/brand/LOGO-SEC.png"
                      : "") ||
                    (login?.jobTypeFlags?.jobTypeId === 5
                      ? "assets/images/brand/LOGO-YUM.png"
                      : "") ||
                    "assets/images/brand/EMPLOYER.png"
                }
                className="header-brand-img light-logo1"
                alt="logo"
              />
            </a>
          </div>
          <div className="main-sidemenu just-between" style={{ marginLeft: '-9px' }}>
            <div className="slide-left disabled" id="slide-left">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                fill="#7b8191"
                width="24"
                height="24"
                viewBox="0 0 24 24"
              >
                <path d="M13.293 6.293 7.586 12l5.707 5.707 1.414-1.414L10.414 12l4.293-4.293z"></path>
              </svg>
            </div>
            <ul className="side-menu side-menu-margin margin-bottom">
              {/* <li className="sub-category">
                                <h3>Main</h3>
                            </li> */}

              {/* if (Environment) {
                                
                            } */}
              {/* {
                                Environment !== 'development' && <li className="slide">
                                <a className="side-menu__item" data-bs-toggle="slide" href="#" onClick={(event) => {
                                    event.preventDefault();
                                        navigate('/dashboard');
                                }}>
                                    <i className="side-menu__icon fe fe-home"></i>
                                    <span className="side-menu__label">Dashboard</span>
                                </a>
                            </li>
                            } */}

              <li className="slide is-expanded">
                <a
                  className="side-menu__item"
                  data-bs-toggle="slide"
                  href="javascript:void(0)"
                  onClick={() => {
                    setCandidateMenu(!candidateMenu);
                  }}

                >
                  <i className="side-menu__icon fa fa-users" style={{ fontSize: '25px', color: '#004D40' }}></i>
                  <span className="side-menu__label">Candidates</span>
                  <button
                    id="bAcep"
                    type="button"
                    class="btn btn-height side-menu__icon"
                    style={{ fontSize: "0.8rem", }}
                  >
                    {candidateMenu ? <FiChevronDown /> : <FiChevronRight />}
                  </button>
                </a>
                {candidateMenu && (
                  <ul className="slide-menu open">
                    <li className="is-expanded">
                      <a
                        className="sub-slide-item"
                        data-bs-toggle="slide"
                        href="#"
                        onClick={(event) => {
                          event.preventDefault();
                          navigate("/locationmaps");
                        }}
                      >
                        <span className="side-menu__label">Maps</span>
                      </a>
                    </li>
                    <li className="is-expanded">
                      <a
                        className="sub-slide-item"
                        data-bs-toggle="slide"
                        href="#"
                        onClick={() => {
                          setShowSearch(!showSearch);
                        }}
                      >
                        <span className="side-menu__label">Search</span>
                        {showSearch ? <FiChevronDown /> : <FiChevronRight />}
                      </a>
                      {showSearch && (
                        <ul className="slide-menu open">
                          <li className="is-expanded">
                            <a
                              className="sub-slide-item"
                              data-bs-toggle="slide"
                              href="#"
                              onClick={(event) => {
                                event.preventDefault();
                                navigate("/newcandidatesearchv2");
                              }}
                            >
                              <span className="side-menu__label">
                                New Candidate Search
                              </span>
                            </a>
                          </li>
                          {/* <li className="is-expanded">
                                                <a className="sub-slide-item" data-bs-toggle="slide" href="#" onClick={(event) => {
                                                    event.preventDefault();
                                                    navigate('/newcandidatesearchv2');
                                                }}
                                                ><span className="side-menu__label">New Candidate Search 2</span></a>
                                            </li> */}
                          <li className="is-expanded">
                            <a
                              className="sub-slide-item"
                              data-bs-toggle="slide"
                              href="#"
                              onClick={(event) => {
                                event.preventDefault();
                                navigate("/searchwithcriteriav2");
                              }}
                            >
                              <span className="side-menu__label">
                                Search With Criteria
                              </span>
                            </a>
                          </li>
                          {/* <li className="is-expanded">
                                                <a className="sub-slide-item" data-bs-toggle="slide" href="#" onClick={(event) => {
                                                    event.preventDefault();
                                                    navigate('/searchwithcriteriav2');
                                                }}
                                                ><span className="side-menu__label">Search With Criteria 2</span></a>
                                            </li> */}
                        </ul>
                      )}
                    </li>
                    {/* {<li className="is-expanded">
                                        <a className="sub-slide-item" data-bs-toggle="slide" href="#" onClick={(event) => {
                                            event.preventDefault();
                                            navigate("/joblist");
                                        }}
                                        ><span className="side-menu__label">List Job Opportunities</span>
                                        </a>
                                    </li> } */}

                    {/* <li className="is-expanded">
                                        <a className="sub-slide-item" data-bs-toggle="slide" href="#"
                                        ><span className="side-menu__label">Create Job Opportunity</span>
                                        </a>
                                       
                                    </li> */}
                  </ul>
                )}
              </li>

              {
                <li className="slide is-expanded">
                  <a
                    className="side-menu__item"
                    data-bs-toggle="slide"
                    href="javascript:void(0)"
                    onClick={() => {
                      setCreateJobOpp(!createjobopp);
                    }}
                  >
                    <i className="side-menu__icon zmdi zmdi-hospital mx-1" style={{ fontSize: '27px', color: '#004D40' }}></i>
                    <span className="side-menu__label">
                      Create Shift Opportunity
                    </span>
                    <button
                      id="bAcep"
                      type="button"
                      class="btn btn-height side-menu__icon"
                      style={{ fontSize: "0.8rem", }}
                    >
                      {createjobopp ? <FiChevronDown /> : <FiChevronRight />}
                    </button>
                  </a>
                  {createjobopp && (
                    <ul className="slide-menu open">
                      <li className="is-expanded">
                        <ul className="slide-menu open">
                          <li class="is-expanded">
                            <a
                              className="sub-slide-item"
                              data-bs-toggle="slide"
                              href="#"
                              onClick={(event) => {
                                event.preventDefault();
                                dispatch(resetJobOpportunityInfo()).then(() => {
                                  dispatch(startNewPost()).then(() => {
                                    navigate("/jobopportunity", {
                                      state: {
                                        postion: {
                                          newPost: true,
                                          fromTemplate: false,
                                          createTemplate: false,
                                          editJobPost: false,
                                        },
                                      },
                                    });
                                  });
                                });
                              }}
                            >
                              <span className="side-menu__label">
                                Start with a new post
                              </span>
                            </a>
                          </li>
                          <li class="is-expanded">
                            <a
                              className="sub-slide-item"
                              data-bs-toggle="slide"
                              href="#"
                              onClick={(event) => {
                                event.preventDefault();
                                dispatch(resetJobOpportunityInfo()).then(() => {
                                  dispatch(startWithTemplate()).then(() => {
                                    navigate("/jobopportunity", {
                                      state: {
                                        postion: {
                                          newPost: false,
                                          fromTemplate: true,
                                          createTemplate: false,
                                          editJobPost: false,
                                        },
                                      },
                                    });
                                  });
                                });
                              }}
                            >
                              <span className="side-menu__label">
                                Start with a Template
                              </span>
                            </a>
                          </li>
                          <li class="is-expanded">
                            <a
                              className="sub-slide-item"
                              data-bs-toggle="slide"
                              href="#"
                              onClick={(event) => {
                                event.preventDefault();
                                dispatch(resetJobOpportunityInfo()).then(() => {
                                  dispatch(createTemplate()).then(() => {
                                    navigate("/jobopportunity", {
                                      state: {
                                        postion: {
                                          newPost: false,
                                          fromTemplate: false,
                                          createTemplate: true,
                                          editJobPost: false,
                                        },
                                      },
                                    });
                                  });
                                });
                              }}
                            >
                              <span className="side-menu__label">
                                Create a template
                              </span>
                            </a>
                          </li>
                          <li class="is-expanded">
                            <a
                              className="sub-slide-item"
                              data-bs-toggle="slide"
                              href="#"
                              onClick={(event) => {
                                event.preventDefault();
                                dispatch(resetJobOpportunityInfo()).then(() => {
                                  navigate("/template-list");
                                })
                              }}
                            >
                              <span className="side-menu__label">
                              Template List
                              </span>
                            </a>
                          </li>
                        </ul>
                      </li>
                    </ul>
                  )}
                </li>
              }

              {
                <li className="slide is-expanded">
                  <a
                    className="side-menu__item"
                    data-bs-toggle="slide"
                    href="javascript:void(0)"
                    onClick={() => {
                      setemployerDashboardMenu(!employerDashboardMenu);
                    }}
                  >
                    <i className="side-menu__icon fe fe-layers" style={{ fontSize: '25px', color: '#004D40' }}></i>
                    <span className="side-menu__label">Employer Dashboard</span>
                    <button
                      id="bAcep"
                      type="button"
                      class="btn btn-height side-menu__icon"
                      style={{ fontSize: "0.8rem", paddingLeft: "15px" }}
                    >
                      {employerDashboardMenu ? (
                        <FiChevronDown />
                      ) : (
                        <FiChevronRight />
                      )}
                    </button>
                  </a>
                  {employerDashboardMenu && (
                    <ul className="slide-menu open">
                      <li className="is-expanded">
                        <ul className="slide-menu open">
                          <li class="is-expanded">
                            <a
                              className="sub-slide-item"
                              data-bs-toggle="slide"
                              href="#"
                              onClick={(event) => {
                                event.preventDefault();
                                navigate("/openshifts");
                              }}
                            >
                              <span className="side-menu__label">
                                Open Shifts
                              </span>
                            </a>
                          </li>
                          <li class="is-expanded">
                            <a
                              className="sub-slide-item"
                              data-bs-toggle="slide"
                              href="#"
                              onClick={(event) => {
                                event.preventDefault();
                                navigate("/awaitingcorrection");
                              }}
                            >
                              <span className="side-menu__label">
                              Shifts Awaiting Correction
                              </span>
                              {shiftsAwaitingCorrectionCount ? (
                                <span className="blink badge mx-1" style={{backgroundColor: '#004D40'}}>
                                  {shiftsAwaitingCorrectionCount}
                                </span>
                              ) : (
                                ""
                              )}
                            </a>
                          </li>
                          <li class="is-expanded">
                            <a
                              className="sub-slide-item"
                              data-bs-toggle="slide"
                              href="#"
                              onClick={(event) => {
                                event.preventDefault();
                                navigate("/awaitingshifts");
                              }}
                            >
                              <span className="side-menu__label">
                                Shifts Awaiting Approval
                              </span>
                              {shiftsAwaitingApprovalCount ? (
                                <span className="blink badge" style={{backgroundColor: '#004D40'}}>
                                  {shiftsAwaitingApprovalCount}
                                </span>
                              ) : (
                                ""
                              )}
                            </a>
                          </li>
                          <li class="is-expanded">
                            <a
                              className="sub-slide-item"
                              data-bs-toggle="slide"
                              href="#"
                              onClick={(event) => {
                                event.preventDefault();
                                navigate("/awaitingpayments");
                              }}
                            >
                              <span className="side-menu__label">
                                Shifts Awaiting Payment
                              </span>
                              {shiftsAwaitingPaymentCount ? (
                                <span className="blink badge" style={{backgroundColor: '#004D40'}}>
                                  {shiftsAwaitingPaymentCount}
                                </span>
                              ) : (
                                ""
                              )}
                            </a>
                          </li>
                          <li class="is-expanded">
                            <a
                              className="sub-slide-item"
                              data-bs-toggle="slide"
                              href="#"
                              onClick={(event) => {
                                event.preventDefault();
                                navigate("/completedshifts");
                              }}
                            >
                              <span className="side-menu__label">
                                Completed Shifts
                              </span>
                            </a>
                          </li>
                          <li class="is-expanded">
                            <a
                              className="sub-slide-item"
                              data-bs-toggle="slide"
                              href="#"
                              onClick={(event) => {
                                event.preventDefault();
                                navigate("/shiftscoverage");
                              }}
                            >
                              <span className="side-menu__label">
                                All Shifts
                              </span>
                            </a>
                          </li>
                        </ul>
                      </li>
                    </ul>
                  )}
                </li>
              }

              {
                <li className="slide is-expanded">
                  <a
                    style={{paddingRight:0}}
                    className="side-menu__item"
                    data-bs-toggle="slide"
                    href="#"
                    onClick={(event) => {
                      event.preventDefault();
                      navigate("/messages");
                    }}
                  >
                    <i className="side-menu__icon fa fa-solid fa-bell" style={{ fontSize: '28px', color: '#004D40' }}></i>
                    <span className="side-menu__label">Notifications</span>
                    {notificationCount ? (
                      <span className="blink badge hide-notify-count" style={{backgroundColor: '#004D40'}}>
                        {notificationCount}
                      </span>
                    ) : (
                      ""
                    )}
                  </a>
                </li>
              }
              {
                <li className="slide is-expanded">
                  <a
                    style={{paddingRight:0}}
                    className="side-menu__item"
                    data-bs-toggle="slide"
                    href="#"
                    onClick={(event) => {
                      event.preventDefault();
                      navigate("/notifications");
                    }}
                  >
                    <i className="side-menu__icon fa fa-arrow-circle-up" style={{ fontSize: '30px', color: "#004D40" }}></i>
                    <span className="side-menu__label">Uploads</span>
                    {uploadCount ? (
                      <span className="blink badge hide-notify-count" style={{backgroundColor: '#004D40'}}>
                        {uploadCount}
                      </span>
                    ) : (
                      ""
                    )}
                  </a>
                </li>
              }
              {
                <li className="slide is-expanded">
                  <span
                    style={{ cursor: "pointer" ,paddingRight:0}}
                    className="side-menu__item"
                    data-bs-toggle="slide"

                    onClick={(event) => {
                      event.preventDefault();
                      navigate("/inbox");
                    }}
                  >
                    <span className="connection"><i
                      class="ti-email"
                      style={{
                        color: "#fff",
                        fontWeight: '500',
                        fontSize: '18px'
                      }}
                    ></i></span>
                    <span className="side-menu__label ms-2">Email</span>
                    {inboxMailCount ? (
                      <span className="blink badge hide-notify-count" style={{backgroundColor: '#004D40'}}>
                        {inboxMailCount}
                      </span>
                    ) : (
                      ""
                    )}
                  </span>
                </li>
              }
              {
                <li className="slide is-expanded">
                  <a
                    style={{paddingRight:0}}
                    className="side-menu__item"
                    data-bs-toggle="slide"
                    href="#"
                    onClick={(event) => {
                      event.preventDefault();
                      navigate("/texts");
                    }}
                  >
                    <span className="connection"> <i
                      class="fa fa fa-commenting-o"
                      style={{ fontSize: '18px', cursor: "pointer", color: "#fff" }}
                    ></i></span>
                    <span className="side-menu__label ms-2">Texts</span>
                    {smsCount ? (
                      <span className="blink badge hide-notify-count" style={{backgroundColor: '#004D40'}}>
                        {smsCount}
                      </span>
                    ) : (
                      ""
                    )}
                  </a>
                </li>
              }
              {
                <li className="slide is-expanded">
                  <a
                  style={{paddingRight:0}}
                    className="side-menu__item"
                    data-bs-toggle="slide"
                    href="#"
                    onClick={(event) => {
                      event.preventDefault();
                      navigate("/gps-incidents");
                    }}
                  >
                    <span className="side-menu__icon"><FiAlertTriangle size={28} color="#e82646" /></span>
                    <span className="side-menu__label ms-2">Incident Report</span>
                    {incidentCount ? (
                      <span className="blink badge hide-notify-count" style={{backgroundColor: '#004D40'}}>
                        {incidentCount}
                      </span>
                    ) : (
                      ""
                    )}
                  </a>
                </li>
              }
              {
                <li className="slide is-expanded">
                  <a
                    className="side-menu__item"
                    data-bs-toggle="slide"
                    href="#"
                    onClick={(event) => {
                      event.preventDefault();
                      navigate("/powerbi");
                    }}
                  >
                    <i className="side-menu__icon fe fe-layers"></i>
                    <span className="side-menu__label">
                      Reporting Dashboard
                    </span>
                  </a>
                </li>
              }
              {/* 

              {/* <li className="slide">
                                <a className="side-menu__item" data-bs-toggle="slide" href="#"
                                   onClick={navigateToProfile}><i
                                    className="side-menu__icon fe fe-layers"></i><span className="side-menu__label">Profile Builder</span></a>

                            </li> */}
              {/*<li className="slide">
                            <a className="side-menu__item" data-bs-toggle="slide" href="ProfileEdit.html"><i
                                className="side-menu__icon fe fe-users"></i><span className="side-menu__label">My Account</span><i
                                className="angle fe fe-chevron-right"></i></a>

                            <ul className="slide-menu open">
                                <li className="is-expanded"><a href="ProfileEdit.html" className="sub-slide-item">My
                                    Account</a></li>
                                <li className="is-expanded"><a href="BankAccount.html" className="sub-slide-item">Bank
                                    Account</a></li>

                            </ul>
    </li>*/}

              <li className="slide is-expanded">
                <a
                  className="side-menu__item"
                  data-bs-toggle="slide"
                  href="#"
                  onClick={showTeams}
                >
                  <i className="side-menu__icon fa fa-users" style={{ fontSize: '25px', color: '#004D40' }}></i>
                  <span class="side-menu__label">Teams</span>
                  <button
                    id="bAcep"
                    type="button"
                    class="btn btn-height side-menu__icon"
                    style={{ fontSize: "0.8rem", paddingLeft: "15px" }}
                  >
                    {subnav ? <FiChevronDown /> : <FiChevronRight />}
                  </button>
                </a>
                {teams && (
                  <ul class="slide-menu open">
                    <li class="is-expanded">
                      <a
                        className="sub-slide-item"
                        data-bs-toggle="slide"
                        href="#"
                        onClick={(event) => {
                          event.preventDefault();
                          navigate("/createteam");
                        }}
                      >
                        <span className="side-menu__label">Create Team</span>
                      </a>
                    </li>

                    <li class="is-expanded">
                      <a
                        className="sub-slide-item"
                        data-bs-toggle="slide"
                        href="#"
                        onClick={(event) => {
                          event.preventDefault();
                          navigate("/listteams");
                        }}
                      >
                        <span className="side-menu__label">List Teams</span>
                      </a>
                    </li>

                  </ul>




                )}
              </li>

              <li className="slide is-expanded">
                <a
                  className="side-menu__item"
                  data-bs-toggle="slide"
                  href="javascript:void(0)"
                  onClick={showSubNav}
                >
                  <i className="side-menu__icon fe fe-settings" style={{ fontSize: '25px', color: '#004D40' }}></i>
                  <span class="side-menu__label">Settings</span>
                  <button
                    id="bAcep"
                    type="button"
                    class="btn btn-height side-menu__icon"
                    style={{ fontSize: "0.8rem", paddingLeft: "15px" }}
                  >
                    {subnav ? <FiChevronDown /> : <FiChevronRight />}
                  </button>
                </a>
                {subnav && (
                  <ul class="slide-menu open">
                    <li class="is-expanded">
                      <a
                        className="sub-slide-item"
                        data-bs-toggle="slide"
                        href="#"
                        onClick={(event) => {
                          event.preventDefault();
                          if (window.location.pathname === "/addcompany") {
                            navigate("/addcompany");
                            window.location.reload(false);
                          } else {
                            navigate("/addcompany");
                          }
                        }}
                      >
                        <span className="side-menu__label">Company Detail</span>
                      </a>
                    </li>
                    {/* <li class="is-expanded">
                      <a
                        className="sub-slide-item"
                        data-bs-toggle="slide"
                        href="#"
                        onClick={(event) => {
                          event.preventDefault();
                          if (
                            window.location.pathname === "/employersettings"
                          ) {
                            navigate("/employersettings");
                            window.location.reload(false);
                          } else {
                            navigate("/employersettings");
                          }
                        }}
                      >
                        <span className="side-menu__label">
                          Employer Settings
                        </span>
                      </a>
                    </li> */}
                    <li class="is-expanded">
                      <a
                        className="sub-slide-item"
                        data-bs-toggle="slide"
                        href="#"
                        onClick={(event) => {
                          event.preventDefault();
                          navigate("/addlocations", {
                                  state: {
                                    contacts: "false",
                                    hideContact: true,
                                    isMapActive: false,
                                  },
                                });
                        }}
                        // onClick={(event) => {
                        //   event.preventDefault();
                        //   if (window.location.pathname === "/addlocations") {
                        //     navigate("/addlocations", {
                        //       state: {
                        //         contacts: "false",
                        //         hideContact: true,
                        //         isMapActive: false,
                        //       },
                        //     });
                        //     window.location.reload(false);
                        //   } else {
                        //     navigate("/addlocations", {
                        //       state: {
                        //         contacts: "false",
                        //         hideContact: true,
                        //         isMapActive: false,
                        //       },
                        //     });
                        //   }
                        // }}
                      >
                        <span className="side-menu__label">Add Location</span>
                      </a>
                    </li>
                    <li class="is-expanded">
                      <a
                        className="sub-slide-item"
                        data-bs-toggle="slide"
                        href="#"
                        onClick={(event) => {
                          event.preventDefault();
                          // if (window.location.pathname === "/locations") {
                            navigate("/locations");
                            // window.location.reload(false);
                          // } else {
                            // navigate("/locations");
                          // }
                        }}
                      >
                        <span className="side-menu__label">Locations</span>
                      </a>
                    </li>

                    <li class="is-expanded">
                      <a
                        className="sub-slide-item"
                        data-bs-toggle="slide"
                        href="#"
                        onClick={(event) => {
                          event.preventDefault();
                          if (window.location.pathname === "/adduser") {
                            navigate("/adduser", {
                              state: {
                                editUser: false,
                              },
                            });
                            window.location.reload(false);
                          } else {
                            navigate("/adduser", {
                              state: {
                                editUser: false,
                              },
                            });
                          }
                        }}
                      >
                        <span className="side-menu__label">Add User</span>
                      </a>
                    </li>
                    <li class="is-expanded">
                      <a
                        className="sub-slide-item"
                        data-bs-toggle="slide"
                        href="#"
                        onClick={() => changeLocation("/user")}
                      >
                        <span className="side-menu__label">Users</span>
                      </a>
                    </li>
                    <li class="is-expanded">
                      <a
                        className="sub-slide-item"
                        data-bs-toggle="slide"
                        href="#"
                        onClick={(event) => {
                          event.preventDefault();
                          if (window.location.pathname === "/contacts") {
                            navigate("/contacts");
                            window.location.reload(false);
                          } else {
                            navigate("/contacts");
                          }
                        }}
                      >
                        <span className="side-menu__label">Contacts</span>
                      </a>
                    </li>
                    <li class="is-expanded">
                      <a
                        className="sub-slide-item"
                        data-bs-toggle="slide"
                        href="#"
                        onClick={(event) => {
                          event.preventDefault();
                          if (window.location.pathname === "/departments") {
                            navigate("/departments");
                            window.location.reload(false);
                          } else {
                            navigate("/departments");
                          }
                        }}
                      >
                        <span className="side-menu__label">Create Department</span>
                      </a>
                    </li>
                    <li class="is-expanded">
                      <a
                        className="sub-slide-item"
                        data-bs-toggle="slide"
                        href="#"
                        onClick={(event) => {
                          event.preventDefault();
                          if (window.location.pathname === "/departments-list") {
                            navigate("/departments-list");
                            window.location.reload(false);
                          } else {
                            navigate("/departments-list");
                          }
                        }}
                      >
                        <span className="side-menu__label">Department List</span>
                      </a>
                    </li>
                  </ul>
                )}
              </li>

              <li className="slide is-expanded">
                <a
                  className="side-menu__item mx-1"
                  data-bs-toggle="slide"
                  href="javascript:void(0)"
                  onClick={showUserProfile}
                >
                  <i className="side-menu__icon fa fa-user" style={{ fontSize: '25px', color: '#004D40' }}></i>
                  {/* <img
                                        src="assets/images/users/nurseuserm.jpg"
                                        alt="profile-user"
                                        className="avatar  profile-user brround cover-image"
                                    /> */}
                  <span class="side-menu__label">
                    Login User Details
                    {/* {login && login.fullName} */}
                  </span>
                  <button
                    id="bAcep"
                    type="button"
                    class="btn btn-height side-menu__icon"
                    style={{ fontSize: "0.8rem", paddingLeft: "15px" }}
                  >
                    {userProfile ? <FiChevronDown /> : <FiChevronRight />}
                  </button>
                </a>
                {userProfile && (
                  <ul class="slide-menu open">
                    <li class="is-expanded">
                      <a
                        className="sub-slide-item"
                        data-bs-toggle="slide"
                        href="#"
                        onClick={(event) => {
                          event.preventDefault();
                          navigate("/employerProfile");
                        }}
                      >
                        <span className="side-menu__label">Profile</span>
                      </a>
                    </li>
                    <li class="is-expanded">
                      <a
                        className="sub-slide-item"
                        data-bs-toggle="slide"
                        href="#"
                        onClick={(event) => {
                          event.preventDefault();
                          navigate("/updatepassword");
                        }}
                      >
                        <span className="side-menu__label">
                          Update password
                        </span>
                      </a>
                    </li>
                    <li class="is-expanded">
                      <a
                        className="sub-slide-item"
                        data-bs-toggle="slide"
                        href="#"
                        onClick={logout}
                      >
                        <span className="side-menu__label">Signout</span>
                      </a>
                    </li>
                  </ul>
                )}
              </li>
            </ul>

            {/* <ul className="side-menu side-menu-margin user-profile">
                            
                        </ul> */}

            <div className="slide-right" id="slide-right">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                fill="#7b8191"
                width="24"
                height="24"
                viewBox="0 0 24 24"
              >
                <path d="M10.707 17.707 16.414 12l-5.707-5.707-1.414 1.414L13.586 12l-4.293 4.293z"></path>
              </svg>
            </div>
          </div>
          <div className="ps__rail-x rail">
            <div className="ps__thumb-x railthumb" tabIndex="0"></div>
          </div>
          <div className="ps__rail-y railright">
            <div className="ps__thumb-y railrightthumb" tabIndex="0"></div>
          </div>
        </div>
      </div>
      {/* <div className="jumps-prevent jump-padding"></div> */}
    </>
  );
};
